import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";

const apiFetchHeaderDetails = async (neighborhoodId: string) => {
  const response = await http.get(URL.FETCH_HEADER(neighborhoodId));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};
const apiFetchDivisions = async () => {
  const response = await http.get(URL.FETCH_DIVISIONS());
  if (!response) {
    throw new Error(response.status);
  }
  return response || null;
};
const apiFetchCommunities = async (divisionId: string) => {
  const response = await http.get(URL.FETCH_COMMUNITIES(divisionId));
  if (!response) {
    throw new Error(response.status);
  }
  return response || null;
};

export { apiFetchHeaderDetails, apiFetchCommunities, apiFetchDivisions };
